import { useMemo } from 'react';

export const useLocalDateTime = () => {
  const formatDateTime = (utcDateStr, options = {}) => {
    if (!utcDateStr) return '';

    try {
      const cleanUtc = utcDateStr.replace(/(\.\d{3})\d+/, '$1');
      const utcInput = cleanUtc.endsWith('Z') ? cleanUtc : `${cleanUtc}Z`;

      const date = new Date(utcInput);
      if (isNaN(date)) {
        console.warn('Invalid UTC date string:', utcDateStr);
        return '';
      }

      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const formatter = new Intl.DateTimeFormat(undefined, {
        timeZone,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short',
        ...options,
      });

      return formatter.format(date);
    } catch (err) {
      console.warn('Error formatting date:', utcDateStr, err);
      return '';
    }
  };

  return useMemo(() => ({ formatDateTime }), []);
};